import { GzRmIconWebComponent } from './component/GzRmIconWebComponent';

export { GzRmIconWebComponent };
